import { AuthData } from "./auth";
import { CatalogData } from "./catalog";
import { CategoriaData } from "./categoria";
import { CategoriesData } from "./categories";
import { CheckInData } from "./checkIn";
import { ClientData } from "./client";
import { CommercialSampleData } from "./commercial-sample";
import { CouponsData } from "./coupons";
import { EmailProvider } from "./email";
import { EmbedService } from "./embed.service";
import { EmployeeService } from "./employee.service";
import { EventData } from "./event";
import { FileData } from "./file";
import { GenFormBuilder } from "./form";
import { GalleryService } from "./gallery.service";
import { GamificationData } from "./gamification";
import { HistoryData } from "./history";
import { InteractivityData } from "./interactivity";
import { NetworkingService } from "./networking.service";
import { NewsData } from "./news";
import { OpinometerData } from "./opinometer";
import { PaymentProvider } from "./payments";
import { PollData } from "./poll";
import { PQRData } from "./pqr";
import { PurchasesData } from "./purchases";
import { ReportsData } from "./reports";
import { ReserveData } from "./reserve";
import { ServiceService } from "./services.service";
import { ShopsData } from "./shops";
import { SponsorData } from "./sponsor";
import { StaffData } from "./staff";
import { StatisticData } from "./statistics";
import { StorageData } from "./storage";
import { StoreService } from "./store.service";
import { TicketService } from "./ticket.service";
import { TrackingProvider } from "./tracking";
import { UserData } from "./user";
import { Utilities } from "./utilities";
import { VotingData } from "./voting";
import { XlsxData } from "./xlsx";
import { FavoriteService } from "./favorite.service";
import { ReserveService } from "./reserve.service";
import { JobsData } from "./jobs";
import { CustomService } from "./custom.service";
import { LivestreamService } from "./livestream.service";
import { CompanyService } from "./company.service";

export const PROVIDERS = [
  AuthData,
  ClientData,
  EventData,
  UserData,
  StorageData,
  OpinometerData,
  GenFormBuilder,
  SponsorData,
  PQRData,
  NewsData,
  VotingData,
  FileData,
  ReserveData,
  HistoryData,
  StaffData,
  Utilities,
  CatalogData,
  CategoriesData,
  InteractivityData,
  CommercialSampleData,
  TrackingProvider,
  PollData,
  CheckInData,
  GamificationData,
  XlsxData,
  ShopsData,
  PurchasesData,
  StatisticData,
  CategoriaData,
  CouponsData,
  EmailProvider,
  ReportsData,
  PaymentProvider,
  TicketService,
  ServiceService,
  EmbedService,
  GalleryService,
  EmployeeService,
  StoreService,
  FavoriteService,
  NetworkingService,
  ReserveService,
  JobsData,
  CustomService,
  LivestreamService,
  CompanyService,
];



// WEBPACK FOOTER //
// ./src/providers/index.ts